import { MnoConfig } from '../types';

export const mtnSouthAfricaConfig: MnoConfig = {
  id: 'mtn_sa',
  name: 'MTN South Africa',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow (operator color)
  },
  countryCode: '27',
  phoneNumberMask: '00 000 0000', // South African phone format (9 digits)
  appUrl: 'https://mtn.za.life.fun',
  locations: [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North West",
    "Western Cape",
  ],
};

